import { AppBar } from '@mui/material';
import { DropdownMenuAppbar } from './DropdownMenuAppbar';



export const NavbarSmallLayout = () => {

    return (
        <AppBar sx={{ zIndex: 9995 }} position="sticky" color='primary' elevation={0}  >
            <DropdownMenuAppbar/>
        </AppBar>
    )
}